import { render, staticRenderFns } from "./SchoolAwayDetailEditForm.vue?vue&type=template&id=0acab72c&scoped=true&"
import script from "./SchoolAwayDetailEditForm.vue?vue&type=script&lang=js&"
export * from "./SchoolAwayDetailEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acab72c",
  null
  
)

export default component.exports